// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  ServiceType,
} from "./types";

export default {
  name: __t.string(),
  imageUrl: __t.string(),
  get serviceType() {
    return ServiceType;
  },
  description: __t.string(),
  healthPort: __t.u16(),
};
